<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleComprador"
             color="primary" class="normal-btn-text rounded-tag-small elevation-0"
             link to="/configuracoes-nota-entrada/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Nota de Entrada
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque pela nota de entrada ou código"
                      class="rounded-tag-small" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemTipoNotaEntrada', ['stringFilter']),
    ...mapGetters('user', ['hasRoleComprador']),
    searchText: {
      get() {
        return this.$store.getters['listagemTipoNotaEntrada/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemTipoNotaEntrada/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
};
</script>
